// This needs to be aligned with Intercom configuration in Segment
export const IntercomLauncherId = "vendr_marketplace_intercom_launcher";
